import * as React from 'react';
import { Col, Row, Divider } from 'antd';

import GeneralSettingsCol from './components/General';
import ValueSettingsCol from './components/PaymentMethods';
import Form from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface IDeliveryMethodDetailProps {
  domain: string;
  currency: GQL.ICurrency;
  deliveryMethod: GQL.IDeliveryMethod;
  languages: Array<GQL.ILanguage>;
  onSave: (deliveryMethod: GQL.IDeliveryMethod) => void;
  onCancel: () => void;
}

interface IDeliveryMethodDetailState {
  deliveryMethod: GQL.IDeliveryMethod;
  selectedPaymentMethodsIds: string[];
  selectedCountryIds: string[];
  currentLanguage: string;
}

export default class DeliveryMethodDetail extends React.Component<IDeliveryMethodDetailProps, IDeliveryMethodDetailState> {

  constructor(props: IDeliveryMethodDetailProps) {
    super(props);

    this.state = {
      deliveryMethod: props.deliveryMethod || {},
      selectedPaymentMethodsIds: props.deliveryMethod && props.deliveryMethod.paymentMethods
        ? props.deliveryMethod.paymentMethods.map(p => p.id)
        : [],
      selectedCountryIds: props.deliveryMethod && props.deliveryMethod.countries
        ? props.deliveryMethod.countries.map(c => c.id)
        : [],
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { currency, languages } = this.props;
    const { deliveryMethod, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {deliveryMethod
            ? `Delivery method ${deliveryMethod.title ? `"${deliveryMethod.title}"` : ''}`
            : `Delivery methods`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24} lg={11}>
              <GeneralSettingsCol
                currency={currency}
                deliveryMethod={deliveryMethod}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
            <Col lg={1} />
            <Col md={24} lg={11}>
              <ValueSettingsCol
                domain={this.props.domain}
                currency={currency}
                deliveryMethod={deliveryMethod}
                selectedPaymentMethodsIds={this.state.selectedPaymentMethodsIds}
                selectedCountryIds={this.state.selectedCountryIds}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    // vybrané platební metody
    if (name === 'selectedPaymentMethodsIds') {
      this.setState({
        selectedPaymentMethodsIds: value,
      });
    } else if (name === 'selectedCountryIds') {
      this.setState({
        selectedCountryIds: value,
      });
    } else {

      // vše ostatní
      const newValue = (language
        ? { [name]: { ...this.state.deliveryMethod[name], [language]: inputValue } }
        : { [name]: inputValue });
      this.setState({
        deliveryMethod: { ...this.state.deliveryMethod, ...newValue }
      });
    }
  }

  private async save() {
    const deliveryMethod = {...this.state.deliveryMethod, 
      paymentMethodIds: this.state.selectedPaymentMethodsIds,
      countryIds: this.state.selectedCountryIds,
    };
    this.props.onSave(deliveryMethod);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/DeliveryMethodDetail.tsx